export default __webpack_public_path__ + "static/media/sp-logo.c6f821d1.png";